import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1beb92e7&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=1beb92e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.2_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_7gprpqnc7s6aitlohrfuswmoxa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports